/**
 * A booking is one of an event's vendors: the EVENT→VENDOR `VENDOR` entity
 * link, with what happens after the decision typed into its `metadata`
 * (`eventVendorMetadataSchema`) — its stage, the day-of times and contact, the
 * contract and insurance dates, the office's notes and the messaging grants.
 */
/** The Settings list (`AppSettingList.listCode`) a booking's stage comes from. */
export const BOOKING_STAGE_LIST_CODE = 'vendor_booking_stages';
export const BOOKING_STAGE_KINDS = ['open', 'booked', 'declined'];
/** The stages a new office starts with, then the office's to edit in Settings. */
export const DEFAULT_BOOKING_STAGES = [
    { value: 'researching', label: 'Researching', kind: 'open' },
    { value: 'quoted', label: 'Quoted', kind: 'open' },
    { value: 'booked', label: 'Booked', kind: 'booked' },
    { value: 'contract_signed', label: 'Contract signed', kind: 'booked' },
    { value: 'confirmed', label: 'Confirmed', kind: 'booked' },
    { value: 'declined', label: 'Declined', kind: 'declined' },
];
/**
 * The stage list's items as options. An item without a value is dropped, one
 * without a label is named by its value, and one without a kind we know is
 * `booked` — the list is JSON an administrator edits by hand, and a typo there
 * must not make a booked vendor read as declined.
 */
export function bookingStageOptions(items) {
    if (!Array.isArray(items))
        return [];
    return items.flatMap((raw) => {
        const item = raw;
        if (!item || typeof item.value !== 'string' || !item.value.trim())
            return [];
        const label = typeof item.label === 'string' && item.label.trim() ? item.label : item.value;
        const kind = BOOKING_STAGE_KINDS.includes(item.kind)
            ? item.kind
            : 'booked';
        return [{ value: item.value, label, kind }];
    });
}
/**
 * The stage a booking is at. A booking with none stored is at the first
 * `booked` stage — linking a vendor, accepting a quote or booking directly is
 * the decision. A stored value the list no longer has is still shown, by its
 * value, rather than silently read as something else.
 */
export function resolveBookingStage(stored, options) {
    if (typeof stored === 'string' && stored) {
        return (options.find((o) => o.value === stored) ?? { value: stored, label: stored, kind: 'booked' });
    }
    return options.find((o) => o.kind === 'booked') ?? null;
}
//# sourceMappingURL=booking.js.map